export default __webpack_public_path__ + "static/media/6.4e2ad9d1.png";